import React, { FC } from 'react';
import { pxToRem } from '@withjoy/joykit/theme';
import { Box, Flex, TextV2 } from '@withjoy/joykit';
import { VirtualScrollableArea } from '@website-editor/utils/WebsiteEditor.utils';

import { LayoutListItem } from './LayoutListItem';
import { LayoutListProps } from './LayoutList.types';
import { ChevronBack } from '@withjoy/joykit/icons';

export const LayoutList: FC<LayoutListProps> = props => {
  const { handleClose, onItemClicked, items, title, subTitle } = props;
  return (
    <VirtualScrollableArea
      width="100%"
      overflowY="scroll"
      height="100%"
      flexDirection="column"
      borderRight={['0px solid', '1px solid']}
      borderColor={['mono3', 'mono3']}
    >
      <Flex
        paddingX={{ _: 6, sm2: 8 }}
        paddingY={8}
        gap={32}
        flexDirection={'column'}
        overflowY="auto"
      >
        <Flex
          borderRadius={48}
          border="1px solid"
          borderColor="mono3"
          background="white"
          width={8}
          height={8}
          position="absolute"
          padding={2}
          justifyContent="center"
          alignItems="center"
          gap={3}
          left={pxToRem(20)}
          cursor="pointer"
          top={pxToRem(20)}
          onClick={handleClose}
          _hover={{
            backgroundColor: 'mono3',
            borderColor: 'mono5',
          }}
          _active={{
            backgroundColor: 'mono5',
            borderColor: 'mono5',
          }}
        >
          <ChevronBack size={16} />
        </Flex>
        <Box>
          <TextV2
            typographyVariant={'hed6'}
            textAlign={'center'}
            fontWeight={'semibold'}
          >
            {title}
          </TextV2>
          {subTitle && (
            <TextV2
              typographyVariant={'body2'}
              marginTop={2}
              color={'mono12'}
              textAlign={'center'}
            >
              {subTitle}
            </TextV2>
          )}
        </Box>
        {items.map(group => (
          <Flex
            key={group.id}
            flexDirection="column"
            gap={24}
            width={'100%'}
          >
            {group.title && (
              <TextV2
                typographyVariant={'label3'}
                color={'#4951EF'}
              >
                {group.title}
              </TextV2>
            )}
            {group.children.map(item => (
              <LayoutListItem
                key={item.id}
                item={item}
                onItemClicked={onItemClicked}
                variant={item.variant}
              />
            ))}
          </Flex>
        ))}
      </Flex>
    </VirtualScrollableArea>
  );
};
